/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Style from './EnergiaSolarPassoAPasso.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function EnergiaSolarPassoAPasso() {
  return (
    <>
      <section id="energia-solar-passo-a-passo">
        <ContainerHome24>
          <h3 className="passo-a-passo-titulo">Financiar seu projeto de energia solar é simples</h3>
          <div className="passo-a-passo-carrossel">
            <CustomEmblaCarouselHome24
              // loop
              enableBullets
              detectBulletCount
              //hideOverflow
              enableMobileArrows
              enablePrevArrow
              //autoplay={100000}
            >
              {({ className }) => (
                <>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">1</p>
                    <div className="slide-textos">
                      <p className="slide-titulo">Simule seu financiamento</p>
                      <p className="slide-texto">
                        Informe alguns dados e consulte as condições disponíveis para financiar seu
                        projeto.
                      </p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">2</p>
                    <div className="slide-textos">
                      <p className="slide-titulo">Encontre uma loja credenciada</p>
                      <p className="slide-texto">
                        Escolha um parceiro Santander próximo de você para dimensionar e orçar seu
                        sistema de energia solar.
                      </p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">3</p>
                    <div className="slide-textos">
                      <p className="slide-titulo">Faça seu projeto</p>
                      <p className="slide-texto">
                        Com o projeto definido e o crédito aprovado, siga com a contratação e
                        instalação do sistema.
                      </p>
                    </div>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default EnergiaSolarPassoAPasso;
